<br>
<form [formGroup]="parentWorkInfoForm" class="w-100 mt-4" style="position: relative">
  <div class="ui form">
    <div class="field">
      <label>Employment status</label>
      <select formControlName="occupation_id">
        <option *ngFor="let item of occupations" [value]="item.value">{{ item.text }}</option>
      </select>
    </div>

    <div class="field">
      <label>Where do you work?</label>
      <input formControlName="company_name" type="text" placeholder=""/>
    </div>

    <div class="field">
      <label>Work address</label>
      <textarea
        formControlName="address" type="text" placeholder="" style="min-height: initial; height: 40px"
      ></textarea>
    </div>

    <div class="field">
      <label>Work sector</label>
      <select formControlName="work_sector">
        <option *ngFor="let item of sectors" [value]="item.value">{{ item.text }}</option>
      </select>
    </div>

    <div class="field">
      <label>Monthly Income</label>
      <input formControlName="monthly_income" name="salary" type="number"/>
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      [disabled]="!parentWorkInfoForm.valid"
      (click)="submitThisForm(parentWorkInfoForm)"
      type="button"
      class="ui primary button fluid"
    >
      Next
    </button>
  </div>

  <div *ngIf="spinner" class="spinner-container">
    <!-- <i class="fa fa-circle-notch fa-spin fa-3x"></i> -->
    <app-loader></app-loader>
  </div>
</form>
